import { render, hydrate } from 'react-dom';
import ReactEntry from '../../Page/components/ReactEntry';
import { pushError } from '../../pushError';

// TODO: tracking inject
//import * as Sentry from '@sentry/react';
//import { Integrations } from '@sentry/tracing';

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}
let ReactSafeMode = getCookie('ReactSafeMode');

window.ctrlBackup = window.renderCtrItem;

if (ReactSafeMode != '1') {
  try {
    // TODO: tracking inject
    /*
    Sentry.init({
      dsn: 'http://78d18a04d4c84df4baea478fcfef76fb@localhost:9000/3',
      integrations: [new Integrations.BrowserTracing()],

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
    });
    */

    hydrate(<ReactEntry />, document.getElementById('root'));
    window.onerror = function (message, source, lineno, colno, error) {
      if (
        !(
          //IGNORE fontawesome-pro-6.1.1-web-all.min.js Googlebot Problem
          (
            message == 'Uncaught SyntaxError: Invalid or unexpected token' &&
            source.indexOf('fontawesome-pro-6.1.1-web-all.min.js') > 0 &&
            lineno == 2 &&
            (navigator.userAgent.indexOf('Googlebot') > 0 ||
              navigator.userAgent.indexOf('AdsBot-Google-Mobile') > 0)
          )
        )
      )
        pushError('window.onerror', {
          message: message,
          source: source,
          lineno: lineno,
          colno: colno,
          error: error,
        });
    };
  } catch (exception) {
    pushError('hydrate', exception);

    function setCookie(cname, cvalue) {
      var d = new Date();
      d.setTime(d.getTime() + 1 * 60 * 1000); //1 Min
      var expires = 'expires=' + d.toUTCString();
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    setCookie('ReactSafeMode', '1');
    location.reload();
  }
}
